function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.39069 24.2773L24.2773 2.3907C24.8166 1.85141 25.691 1.85141 26.2303 2.3907L48.1169 24.2773C48.6562 24.8166 48.6562 25.691 48.1169 26.2303L26.2303 48.1169C25.691 48.6562 24.8166 48.6562 24.2773 48.1169L2.39069 26.2303C1.8514 25.691 1.8514 24.8166 2.39069 24.2773Z",
  fill: "#FE7A00",
  stroke: "#CD2500",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.4417 14.903L26.8617 27.605H23.1642L22.5697 14.903H27.4417ZM25.0057 30.244C25.7403 30.244 26.359 30.505 26.8617 31.027C27.374 31.5393 27.6302 32.1532 27.6302 32.8685C27.6302 33.5838 27.374 34.2025 26.8617 34.7245C26.359 35.2368 25.7403 35.493 25.0057 35.493C24.2903 35.493 23.6717 35.2368 23.1497 34.7245C22.6373 34.2025 22.3812 33.5838 22.3812 32.8685C22.3812 32.1532 22.6373 31.5393 23.1497 31.027C23.6717 30.505 24.2903 30.244 25.0057 30.244Z",
  fill: "black"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 50,
  height: 50,
  fill: "white"
})));

var SvgLimited = function SvgLimited(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLimited, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/limited.c9fb96cd.svg";
export { ForwardRef as ReactComponent };